const LayoutStyle = {
    // layout  style

    container: {
        display: 'flex',
        flexDirection: 'column',
        minHeight: '100vh',
        bgcolor: 'background',
        color: 'text.primary'
    },
    body: {
        display: 'flex',
        flexDirection: 'column',
        flexGrow: 1,
        pt: 1,

        scrollBehavior: 'smooth',
        overflowX: 'hidden',
        overflowY: 'scroll',
        msOverflowStyle: 'none',
        scrollbarWidth: 'none',
        '&::-webkit-scrollbar': {
            display: 'none'
        },
        WebkitFontSmoothing: 'antialiased',
        MozOsxFontSmoothing: 'grayscale',
        '&::-webkit-scrollbar-track': {
            background: 'transparent'
        },

        minHeight: '100%',
        bgcolor: 'default',
        px: {
            xs: 0,
            sm: 'auto'
        }
    },
    navbar: {
        color: 'navbar.text',
        bgcolor: 'navbar.background',
        display: 'flex',
        alignItems: 'center',
        zIndex: 9999
    },
    logoContainer: {
        bgcolor: 'transparent',
        '&:hover': {
            cursor: 'pointer'
        }
    },
    logoStyle: {
        width: {
            xs: 20,
            sm: 29
        },
        height: {
            xs: 20,
            sm: 29
        },
        mr: 1.2
    },

    // mobile drawer style
    drawer: {
        container: {
            width: window.innerWidth,
            height: '100%',
            transition: 'all 0.5s ease-in-out',
            '&.open': {
                transform: 'translateX(0%) !important'
            },
            '&.close': {
                transform: 'translateX(-100%) !important'
            },
            '& .MuiDrawer-paper': {
                width: '100%',
                height: '100%',
                bgcolor: 'background.default'
            },
            '& .MuiDrawer-paperAnchorDockedLeft': {
                border: 'none',
                boxShadow: 'none'
            }
        },
        toolbar: {
            bgcolor: 'navbar.background',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between'
        },
        logoImg: {
            width: 29,
            height: 29,
            mr: 1.2
        },
        logaText: {
            color: 'black',
            fontSize: 14,
            fontWeight: '900',
            mx: 1
        },
        avatar: {
            width: 29,
            height: 29,
            mr: 2
        },
        closeIcon: {
            cursor: 'pointer',
            textAlign: 'right'
        },
        body: {
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'space-between',
            height: '100%',
            width: '100%',
            bgcolor: 'background.default'
        },
        list: {
            width: '100%'
        }
    }
};

export default LayoutStyle;
